import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import {Autocomplete, Button, CardHeader, Grid, MenuItem, Paper, Tab, Table, TableBody, TableCell, TableHead, TableRow, TextField} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';

// Green: '✔'
const TICK = <span style={{color: 'green'}}>✔</span>;
// Red: '✘'
const CROSS = <span style={{color: 'red'}}>✘</span>;

export class SquadDonation extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            donationRequests: {
                data: [],
                hide: false
            },
            donationBoxes: {
                data: []
            },
            filter: {
                squads: [],
                selectdSquad: null,
                userId: null,
            }
        }
    }

    componentDidMount(): void {
        this.getSquads();
    }

    async getSquads() {
        const url = `${Config.getInstance.apiUrl}/api/squad_donation/squads`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.get(url, {headers});

        const success = response.status == 200;

        if (success) {
            const data = response.data;
            const {filter} = this.state;

            filter.squads = data.squads;

            this.setState({filter});
        } else {
            PopupMessage.error("Failed to get squads");
        }
    }

    onSquadChange(event) {
        const {filter} = this.state;
        filter.selectdSquad = event.target.value;
        this.setState({filter});
    }

    onSquadSelect(event, value) {
        this.setState({
            filter: {
                ...this.state.filter,
                selectedSquad: value,
            },
        });
    }

    showMetadata(metadata) {
        const str = JSON.stringify(metadata, null, 2);

        PopupMessage.success(str);
    }

    async onSearch() {
        const {filter} = this.state;
        const url = `${Config.getInstance.apiUrl}/api/squad_donation/search`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.get(url, {
            headers, params: {
                squadId: filter.selectedSquad.id,
                userId: filter.userId
            }
        });

        const success = response.data.success;

        if (success) {
            const data = response.data;
            const {donationRequests, donationBoxes} = this.state;

            donationRequests.data = data.requests;
            donationBoxes.data = data.donationBoxes;

            this.setState({
                donationRequests,
                donationBoxes
            });
        } else {
            PopupMessage.error("Failed to search");
        }
    }

    renderDonationRequests() {
        const {donationRequests} = this.state;
        const data = donationRequests.data;

        return <Paper className="root" elevation={0} style={{width: "100%"}}>
            <CardHeader title="Donation Requests" />
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                    const {donationRequests} = this.state;
                    donationRequests.hide = !donationRequests.hide;
                    this.setState({donationRequests});
                }}
            >
                {donationRequests.hide ? "Show" : "Hide"}
            </Button>
            {donationRequests.hide ? null :
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>UserID</TableCell>
                            <TableCell>RequestID</TableCell>
                            <TableCell>Expired</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>isActive</TableCell>
                            <TableCell>Metadata</TableCell>
                            <TableCell>ReadyAt</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            data.map((item, index) => {
                                return <TableRow key={index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{item.userId}</TableCell>
                                    <TableCell>{item.id}</TableCell>
                                    <TableCell>{item.expiredAt}</TableCell>
                                    <TableCell>{item.type}</TableCell>
                                    <TableCell>{item.isActive ? TICK : CROSS}</TableCell>
                                    <TableCell><Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<VisibilityIcon />}
                                        onClick={() => this.showMetadata(item.metadata)}
                                    >
                                        View
                                    </Button></TableCell>
                                    <TableCell>{item.readyAt}</TableCell>
                                </TableRow>
                            })
                        }
                    </TableBody>
                </Table>
            }
        </Paper>
    }

    renderDonationBoxes() {
        const {donationBoxes} = this.state;
        const data = donationBoxes.data;

        return <Paper className="root" elevation={0} style={{width: "100%"}}>
            <CardHeader title="Donation Boxes" />
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>UserID</TableCell>
                        <TableCell>RequestID</TableCell>
                        <TableCell>Expired</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>IsActive</TableCell>
                        <TableCell>Metadata</TableCell>
                        <TableCell>CreatedAt</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        data.map((item, index) => {
                            return <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{item.userId}</TableCell>
                                <TableCell>{item.requestId}</TableCell>
                                <TableCell>{item.expiredAt}</TableCell>
                                <TableCell>{item.type}</TableCell>
                                <TableCell>{item.isActive ? TICK : CROSS}</TableCell>
                                <TableCell><Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => this.showMetadata(item.metadata)}
                                >
                                    View
                                </Button></TableCell>
                                <TableCell>{item.createdAt}</TableCell>
                            </TableRow>
                        })
                    }
                </TableBody>
            </Table>
        </Paper>
    }

    renderFilter() {
        return <Paper className="root" elevation={0} style={{width: "100%"}}>
            <CardHeader title="Squad filter" />
            <Grid container spacing={2}>
                <Grid item container sm={12}>
                    <Grid item sm={6}>
                        {/* Autocomplete for Squads */}
                        <Autocomplete
                            options={this.state.filter.squads} // Array of squads
                            getOptionLabel={(option) => option.name} // Display squad names
                            value={this.state.filter.selectedSquad}
                            onChange={this.onSquadSelect.bind(this)}
                            renderInput={(params) => (
                                <TextField {...params} label="Squad name..." fullWidth />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid item container sm={12} spacing={2}>
                    <Grid item sm={6}>
                        <TextField
                            label="User ID..."
                            fullWidth
                            onChange={(event) => {
                                const {filter} = this.state;
                                filter.userId = event.target.value;
                                this.setState({filter});
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item container sm={12} spacing={2} justifyContent={"flex-end"}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.onSearch();
                        }}
                    >
                        Search
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    }

    render() {
        return <div className="contentPadding" style={{width: "100%"}}>
            <Grid container sm={12} rowSpacing={2}>
                <Grid item container sm={12} rowSpacing={2}>
                    {this.renderFilter()}
                </Grid>
                <Grid item container sm={12} rowSpacing={2}>
                    {this.renderDonationRequests()}
                </Grid>
                <Grid item container sm={12} rowSpacing={2}>
                    {this.renderDonationBoxes()}
                </Grid>
            </Grid>

        </div>
    }
}